import * as HELPER from "../../../src/config/helper";
import {RAGEX_NUMBER_UPTO_4_DECIMAL_PLACES,REMITTANCE_TYPE,TRENCH_LIST} from '../../../src/config/constant';
import { useState,useEffect } from "react";
import moment from 'moment';
import secureStorage from "@src/config/encrypt";
import RemittancePaymentFormID from './RemittancePaymentFormId';
import { useParams } from "react-router-dom";


const RemittanceViewId = (props: any) => {
  const { id,type } = useParams<{ id: string,type:string }>()
  const { isLeadFromAgency,remittanceDetails,setCallReloadApi,callReloadApi,revenue,remittance_status,paymentMadeFrom,ribbonData } = props;
  const validTypes = Object.values(REMITTANCE_TYPE);
  const currentType = validTypes.includes(type) ? type : null;
  const [selectedFilters, setSelectedFilters] = useState<any>({});
  const [errors,SetErrors] = useState<any>({});
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);
  const [isOpsLoggedIn, setIsOpsLoggedIn] = useState(false);
  const [isMakerLoggedIn, setIsMakerLoggedIn] = useState(false);
  const [isCheckerLoggedIn, setIsCheckerLoggedIn] = useState(false);
  const [formReferralChangeDetect, setFormReferralChangeDetect] = useState(false);
  const [formAgencyChangeDetect, setFormAgencyChangeDetect] = useState(false);
  const [viewPaymentInfo, setViewPaymentInfo] = useState(false);
  const [remittanceType, setRemittanceType] = useState<string>("");
  const [currentLoggedInUser, setCurrentLoggedInUser] = useState<number>(0);
  const [roleStatus, setRoleStatus] = useState<any>([]);
  const [isPartnerRemittanceExists , setIsPartnerRemittanceExists] = useState(false);
  const [isReferralRemittanceExists , setIsReferralRemittanceExists] = useState(false);
  const [isAgencyRemittanceExists , setIsAgencyRemittanceExists] = useState(false);
  const [partnerTrenchDetail,setPartnerTrenchDetail] = useState<any>({});
  const [agentCommissionTrenchDetail,setAgentCommissionTrenchDetail] = useState<any>({});
  const [agentPointTrenchDetail,setAgentPointTrenchDetail] = useState<any>({});

  const handleChange = (selectedValue: any, key: string) => {
    let value = selectedValue;
     if (key === 'referral_fee_date') {
      value = moment(selectedValue).format('YYYY-MM-DD');
    }
    if(key === "referral_remittance" || key === "amount_remitted_to_agency" || key === "amount_received_from_agency"){
      // Remove non-numeric chars except dot
      value = String(selectedValue).replace(/[^0-9.]/g, "");
      // Keep only first dot & max 4 decimals
      const match = value.match(RAGEX_NUMBER_UPTO_4_DECIMAL_PLACES);
      value = match ? match[0] : "";
    }
    if(key === "referral_remittance"){
      setFormReferralChangeDetect(true);
    }else{
      setFormAgencyChangeDetect(true)
    }
    setSelectedFilters((prev: any) => ({
      ...prev,
      [key]: value,
    }));
    SetErrors((prev: any) => {
        const updatedErrors = { ...prev };
        delete updatedErrors[key];
        return updatedErrors;
    });
  }

  /**
   * Check if REM_OPS is logged In
   */
  const checkIfAdminIsLoggedIn = () => {
    const authUserInfo = secureStorage.getItem("authUserInfo");
    const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
    if(roleName === "ADMIN"){
      setIsAdminLoggedIn(true);
    }else{
      setIsAdminLoggedIn(false);
    }
  }

  /**
   * Check if REM_OPS is logged In
   */
  const checkIfOpsIsLoggedIn = () => {
    const authUserInfo = secureStorage.getItem("authUserInfo");
    const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
    if(roleName === "REM_OPS"){
      setIsOpsLoggedIn(true);
    }else{
      setIsOpsLoggedIn(false);
    }
  }

  /**
     * Check if Maker is logged In
     */
  const checkIfMakerIsLoggedIn = () => {
    const authUserInfo = secureStorage.getItem("authUserInfo");
    const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
    if(roleName === "REM_FINANCE_MAKER"){
      setIsMakerLoggedIn(true);
    }else{
      setIsMakerLoggedIn(false);
    }
  }

    /**
     * Check if Checker is logged In
     */
  const checkIfCheckerIsLoggedIn = () => {
    const authUserInfo = secureStorage.getItem("authUserInfo");
    const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
    if(roleName === "REM_FINANCE_CHECKER"){
      setIsCheckerLoggedIn(true);
    }else{
      setIsCheckerLoggedIn(false);
    }
  }

  const makePayment = (remitance_type:string) => {
    setRemittanceType(remitance_type);
    setViewPaymentInfo(true);
  }

  const closePaymentPopup = () => {
    setViewPaymentInfo(false);
  }

  const reloadDetail = async () => {
    setCallReloadApi(callReloadApi+1);
  }

  useEffect(() => {
    const authUserInfo = secureStorage.getItem("authUserInfo");
    if(remittance_status.length > 0){
      const roleId = authUserInfo?.user_data?.assigned_role_ids;
      const roleName = HELPER.normalizeRoleName(authUserInfo?.user_data?.assigned_role_name);
      let filteredStatus: any[] = [];
      switch (roleName) {
          case "REM_OPS":
          case "REM_FINANCE_MAKER":
            filteredStatus = (remittance_status || []).filter((item: any) => item.role_id === roleId).map((item: any) => item.value);
              break;
          case "REM_FINANCE_CHECKER":
              // show only records matching user's role
              filteredStatus = (remittance_status || []).filter((item: any) => item.role_id === roleId && item.label === "Ready").map((item: any) => item.value);
              break;
          default:
            filteredStatus = [];
          break;
      }
      setRoleStatus(filteredStatus);
    }
    setCurrentLoggedInUser(+authUserInfo?.user_data?.user_id)
    checkIfAdminIsLoggedIn()
    checkIfOpsIsLoggedIn()
    checkIfMakerIsLoggedIn()
    checkIfCheckerIsLoggedIn()
     // eslint-disable-next-line
     },[remittance_status])

  useEffect(() => {
    if (!remittanceDetails?.length) return;
    const trenchMap: any = {
      [TRENCH_LIST.partner]: setPartnerTrenchDetail,
      [TRENCH_LIST["agency-commission"]]: setAgentCommissionTrenchDetail,
      [TRENCH_LIST["agency-points"]]: setAgentPointTrenchDetail,
    };
    remittanceDetails.forEach((item: any) => {
      const setter = trenchMap[item.remittance_type];
      if (setter) setter(item);
    });
  },[remittanceDetails])

  const getTrenchDisabledState = (trenchDetail: any, trenchType: string) => {
    if (isAdminLoggedIn) {
      return false;
    }

    if (isOpsLoggedIn) {
      return +trenchDetail?.ops_id !== +currentLoggedInUser;
    }

    if (isMakerLoggedIn) {
      return +trenchDetail?.maker_id !== +currentLoggedInUser;
    }

    if (isCheckerLoggedIn) {
      return +trenchDetail?.checker_id !== +currentLoggedInUser;
    }

    return currentType !== trenchType;
  };

  const isPartnerDisabled = getTrenchDisabledState(partnerTrenchDetail, REMITTANCE_TYPE.partner);
  const isAgencyCommissionDisabled = getTrenchDisabledState(agentCommissionTrenchDetail, REMITTANCE_TYPE['agency-commission']);
  const isAgencyPointDisabled = getTrenchDisabledState(agentPointTrenchDetail, REMITTANCE_TYPE['agency-points']);
  return (
    <>
      <div className="remittance-wrapper">
        <div id="partner">
          <RemittancePaymentFormID remittanceDetails={partnerTrenchDetail} callReloadApi = {callReloadApi} setCallReloadApi = {setCallReloadApi} remittance_status={remittance_status} paymentMadeFrom={paymentMadeFrom} isDisabled={isPartnerDisabled} ribbonData={ribbonData}></RemittancePaymentFormID>
        </div>
        <div id="agency-commission">
          <RemittancePaymentFormID remittanceDetails={agentCommissionTrenchDetail} callReloadApi = {callReloadApi} setCallReloadApi = {setCallReloadApi} remittance_status={remittance_status} paymentMadeFrom={paymentMadeFrom} isDisabled={isAgencyCommissionDisabled} ribbonData={ribbonData}></RemittancePaymentFormID>
        </div>
        <div id="agency-points">
          <RemittancePaymentFormID remittanceDetails={agentPointTrenchDetail} callReloadApi = {callReloadApi} setCallReloadApi = {setCallReloadApi} remittance_status={remittance_status} paymentMadeFrom={paymentMadeFrom} isDisabled={isAgencyPointDisabled} ribbonData={ribbonData}></RemittancePaymentFormID>
        </div>
      </div>
    </>
  );
};

export default RemittanceViewId;
